import { plt_microcms } from "../libs/plt_microcms";
import { microCmsAuthType } from "../types/microCmsAuthType";

/**
 * コンテンツ詳細情報取得
 * @param microCmsAuth 
 * @param endpointId 
 * @param contentId 
 * @param draftKeyId
 * @returns
 */
const useFetchContentById = async (
  microCmsAuth: microCmsAuthType,
  endpointId: string,
  contentId: string,
  draftKeyId: string = ""
) => {
  const client = plt_microcms(microCmsAuth.serviceDomain,microCmsAuth.apiKey);

  try {
    const response = await client.get({
      endpoint: endpointId,
      contentId: contentId,
      queries: {
        draftKey: draftKeyId
      }
    })
    return {
      status: "200",
      responseBody: {contents: response}
    }
  } catch (e) {
    console.log(e);
    return { status: "400", responseBody: {}}
  }
}

export default useFetchContentById;